



















import { computed, defineComponent } from '@vue/composition-api';
import { useStore } from '@/store';
import { MutationTypes } from '@/store/mutations';
import ComparisonRow from '@/components/Comparison/ComparisonRow.vue';

export default defineComponent({
    name: 'SellerReviewsRow',
    components: { ComparisonRow },
    setup () {
        const store = useStore();
        const ratings = computed(() => store.getters.sellerRatings);
        const links = computed(() => store.state.dealerReviewLinks);
        const dealerReviewCounts = computed(() => store.state.dealerReviewCounts);

        const openModal = (src: string) => {
            store.commit(MutationTypes.OpenModal, {
                id: 'seller-reviews-modal',
                src: src
            });
        };

        const widths = computed(() => {
            if (!ratings.value) {
                return ['0%', '0%', '0%'];
            }
            return ratings.value.map(rate => {
                const width = (+rate) * 100 / 5;
                return isNaN(width) ? '0%' : `${width}%`;
            });
        });

        return { ratings, links, openModal, widths, dealerReviewCounts };
    }
});
